module.exports = __webpack_public_path__ + "static/media/securityQuestion.622e69a5.png";